import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { Outlet, useParams } from "react-router-dom";

import {
  caseDetail,
  caseLog,
  wipeCaseDetail,
} from "shared/actions/caseDetailActions";

import { AppDispatch } from "store/store";

const CasePage = () => {
  const dispatch = useDispatch<AppDispatch>();

  const params = useParams<{ case_id: string }>();
  let { case_id = "" } = params;
  const caseId = case_id ? parseInt(case_id) : undefined;

  useEffect(() => {
    // Runs once when mounting
    dispatch(wipeCaseDetail());
    return () => {
      // Runs once on unmounting, in reversed order for clarity
      dispatch(wipeCaseDetail());
    };
  }, []);

  useEffect(() => {
    if (caseId) {
      dispatch(caseDetail(caseId));
      dispatch(caseLog(caseId));
    }
  }, [caseId]);

  return <Outlet />;
};

export default CasePage;
